import { graphql } from 'relay-runtime';

export const getCurrentTarget = graphql`
  query StudentSingleSkillTargetGroupQuery($studentId: ID!, $skip: Boolean!) {
    currentTargetGroupByStudentId(studentId: $studentId) @skip(if: $skip) {
      id
      isCurrent
      isActive
      targetGroup {
        id
        name
      }
      user {
        id
      }
    }
  }
`;

export const getStudentSingleSkillQuery = graphql`
  query StudentSingleSkillQuery(
    $studentId: ID!
    $skillCode: String!
    $skip: Boolean!
    $skillAssessmentsByStudentFilter: SkillAssessmentsByStudentFilterInput
    $allUserActionsFilter: AllUserActionFilterInput!
  ) {
    skillAssessmentsByStudentId(studentId: $studentId, filter: $skillAssessmentsByStudentFilter) {
      nodes {
        id
        activityId
        sessionId
        skill {
          id
        }
        score
        maxScore
        sessionCompletedOn
        items {
          id
          score
        }
      }
    }
    currentTargetGroupByStudentId(studentId: $studentId) @skip(if: $skip) {
      id
      isCurrent
      isActive
      targetGroup {
        id
        name
      }
      user {
        id
      }
    }
    skillStatesByStudentId(studentId: $studentId, filter: { skillCodes: [$skillCode] }) {
      id
      inProgress
      readinessScore
      skillAssessment {
        id
        score
        isComplete
        maxScore
      }
      skillSubstate {
        id
        name
        skillState {
          id
          name
        }
      }
      skill {
        id
        code
        name
        summary
        essentialQuestion
        skillStories {
          story
          id
          profession
        }
        vocabularies {
          term
          definition
          id
        }
      }
    }
    allUserActions(first: 1, filter: $allUserActionsFilter, order: [{ timeStamp: DESC }]) {
      nodes {
        timeStamp
        description
        actionType {
          id
          name
        }
      }
    }
    latestCompletedStudentSkillDiagnostic(studentId: $studentId) {
      id
      retakeAssigned
      sessionCompletedOn
    }
  }
`;
